const changeMode = (mode) => {
  const triggers = document.querySelectorAll("[data-packages-trigger]");
  const toggle = document.querySelector("[data-packages-toggle]");
  const prices = document.querySelectorAll("[data-package-price]");

  if (mode === "yearly") {
    toggle.classList.add("is-yearly");
  } else {
    toggle.classList.remove("is-yearly");
  }

  for (const trigger of triggers) {
    if (trigger.dataset.packagesTrigger === mode) {
      trigger.classList.add("is-active");
    } else {
      trigger.classList.remove("is-active");
    }
  }

  for (const price of prices) {
    if (price.classList.contains(`is-${mode}`)) {
      price.classList.add("is-visible");
    } else {
      price.classList.remove("is-visible");
    }
  }
};

const handleScroll = () => {
  const container = document.querySelector("[data-packages-scroll]");
  const inner = container.querySelector("[data-packages-inner");
  const containerRect = container.getBoundingClientRect();
  const innerRect = inner.getBoundingClientRect();

  if (
    containerRect.x + containerRect.width + 5 <
    innerRect.x + innerRect.width
  ) {
    container.classList.add("is-right-hidden");
  } else {
    container.classList.remove("is-right-hidden");
  }

  if (containerRect.x > innerRect.x) {
    container.classList.add("is-left-hidden");
  } else {
    container.classList.remove("is-left-hidden");
  }
};

const packages = () => {
  const container = document.querySelector("[data-packages-scroll]");
  if (container) {
    handleScroll();
    container.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
  }

  let mode = "yearly";

  const triggers = document.querySelectorAll("[data-packages-trigger]");
  const toggle = document.querySelector("[data-packages-toggle]");

  if (!toggle) {
    return;
  }

  for (const trigger of triggers) {
    trigger.addEventListener("click", () => {
      mode = trigger.dataset.packagesTrigger;
      changeMode(mode);
    });
  }

  toggle.addEventListener("click", () => {
    mode = mode === "monthly" ? "yearly" : "monthly";
    changeMode(mode);
  });

  const footnotes = document.querySelectorAll("[data-package-footnote]");
  const footnotesContainer = document.querySelector(
    "[data-packages-footnotes]"
  );
  const footnotesSet = [];
  let index = 1;

  for (const footnote of footnotes) {
    const icon = footnote.querySelector("i");
    const text = footnote.querySelector("span").textContent;
    const existing = footnotesSet.find((footnote) => footnote.text === text);

    if (existing) {
      icon.classList.add(`fa-circle-${existing.index}`);
    } else {
      icon.classList.add(`fa-circle-${index}`);
      footnotesSet.push({ index, text });

      index++;
    }

    footnote.addEventListener("click", (e) => {
      e.preventDefault();

      const footnotes = document.querySelector("#footnotes");
      footnotes.scrollIntoView({ behavior: "smooth", block: "end" });
    });
  }

  for (const footnote of footnotesSet) {
    const item = document.createElement("span");
    item.innerHTML = `<i class="fa-regular fa-circle-${footnote.index}"></i>&nbsp;${footnote.text}`;
    footnotesContainer.appendChild(item);
  }
};

export default packages;
